import { useRequestTimelineBlocks } from '~/modules/resourcing/common/chart/hooks';
import { mapIsoStringtoUtcObject } from '~/modules/common/dates/convert';
import { getTotalHours } from '~/modules/resourcing/common/util';

export const getChartDates = ({
  resourceRequest,
  chartDates,
  projectDefaultScheduleRule
}) => {
  const mappedChartDates = [];
  const resourceRequestStartDate = mapIsoStringtoUtcObject(
    resourceRequest.startDate
  );
  const resourceRequestEndDate = mapIsoStringtoUtcObject(
    resourceRequest.endDate
  );

  chartDates.forEach((date, index) => {
    const requestPeriodBeginsLater =
      resourceRequestStartDate > date.start &&
      resourceRequestStartDate < date.end;

    const requestPeriodEndsEarlier =
      resourceRequestEndDate < date.end && resourceRequestEndDate > date.start;

    const periodStartDate = requestPeriodBeginsLater
      ? resourceRequestStartDate
      : date.start;

    const periodEndDate = requestPeriodEndsEarlier
      ? resourceRequestEndDate
      : date.end;

    if (periodStartDate !== date.start || periodEndDate !== date.end) {
      if (requestPeriodBeginsLater) {
        mappedChartDates.push({
          ...date,
          isOverlay: true,
          totalScheduleHours: getTotalHours({
            quantity: resourceRequest.quantity,
            defaultScheduleRule: projectDefaultScheduleRule,
            startDate: date.start,
            endDate: date.end
          })
        });
        mappedChartDates.push({
          ...date,
          key: `partial-${date.key}`,
          start: periodStartDate,
          end: periodEndDate,
          zIndex: 20,
          isPartialPeriod: true,
          isStartingPartialPeriod: true,
          isOverlay: false
        });
      } else if (requestPeriodEndsEarlier) {
        mappedChartDates.push({
          ...date,
          key: `partial-${date.key}`,
          start: periodStartDate,
          end: periodEndDate,
          zIndex: 20,
          isEndingPartialPeriod: true,
          isPartialPeriod: true,
          isOverlay: false
        });

        mappedChartDates.push({
          ...date,
          totalScheduleHours: getTotalHours({
            quantity: resourceRequest.quantity,
            defaultScheduleRule: projectDefaultScheduleRule,
            startDate: date.start,
            endDate: date.end
          }),
          isOverlay: true
        });
      }
    } else {
      const chartDate =
        periodStartDate >= resourceRequestStartDate &&
        periodEndDate <= resourceRequestEndDate
          ? {
              ...date,
              totalScheduleHours:
                date.totalScheduleHours ||
                getTotalHours({
                  quantity: resourceRequest.quantity,
                  defaultScheduleRule: projectDefaultScheduleRule,
                  startDate: date.start,
                  endDate: date.end
                }),
              isOverlay: false
            }
          : {
              ...date,
              isOverlay: true,
              totalScheduleHours: getTotalHours({
                quantity: resourceRequest.quantity,
                defaultScheduleRule: projectDefaultScheduleRule,
                startDate: periodStartDate,
                endDate: periodEndDate
              })
            };

      mappedChartDates.push(chartDate);
    }
  });

  return mappedChartDates;
};

const useGetDraftRequestPeriods = ({
  resourceRequest,
  chartDates,
  chartStartDate,
  scale,
  projectDefaultScheduleRule
}) => {
  const mappedChartDates = getChartDates({
    resourceRequest,
    chartDates,
    projectDefaultScheduleRule
  });

  const { requestPeriods } = useRequestTimelineBlocks({
    scheduleRules: resourceRequest.scheduleRules,
    chartStartDate,
    scale,
    projectDefaultScheduleRule,
    requestDisplayPeriods: mappedChartDates,
    startDate: chartDates.length
      ? chartDates[0].start
      : mapIsoStringtoUtcObject(resourceRequest.startDate),
    endDate: chartDates.length
      ? chartDates[chartDates.length - 1]
      : mapIsoStringtoUtcObject(resourceRequest.endDate)
  });

  return {
    requestPeriods
  };
};

export default useGetDraftRequestPeriods;
